import { render } from "./ProviderList.vue?vue&type=template&id=43e63dc7"
import script from "./ProviderList.vue?vue&type=script&lang=js"
export * from "./ProviderList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\shame\\.codex\\.chatgpt-projects\\g-p-6a9e6467fc748191a03e695eb5ba59d5\\build-work\\hr-dependent-frontend\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__